import { Typography } from "@mui/material";
import * as React from "react";

export interface DashboardCardTitleProps {
  title: string;
}

export const DashboardCardTitle = ({ title }: DashboardCardTitleProps) => {
    return (
        <Typography
            variant="subtitle1"
            fontWeight={600}
            m=".5rem 1.5rem 1.5rem 1.5rem"
            color=""
        >
            {title}
        </Typography>
    );
};
